import { PinCodePattern, PinEntryFields, SingleDigit } from '@eika-kortbetjening/pin-code';

const pinRegex = /^\d{4}$/; // 1234

const validateAdjacentCiphers = (pin: string): boolean =>
    !new RegExp('(012|123|234|345|456|567|678|789|890|901|098|987|876|765|654|543|432|321|210|109)').test(pin);

const undefinedOrNull = (value: string | number): boolean => value === undefined || value === null;

const validateRecurringCiphers = (pin: string): boolean => {
    const freq: any = {};
    return undefinedOrNull(
        pin
            .split('')
            .map((c) => {
                freq[c] = freq[c] ? freq[c] + 1 : 1;
                return freq[c];
            })

            .find((e) => e > 2),
    );
};

type PinEntryLengthFour = [SingleDigit, SingleDigit, SingleDigit, SingleDigit];

export const isValidPinLength = (pinEntry: PinEntryFields): pinEntry is PinEntryLengthFour =>
    pinEntry.filter((pinCodeEntry) => typeof pinCodeEntry === 'undefined').length === 0;

export const isValidPinPattern = (pinEntry: PinEntryLengthFour): boolean => {
    const pinString = pinEntry.join('');

    return pinRegex.test(pinString) && validateRecurringCiphers(pinString) && validateAdjacentCiphers(pinString);
};

const isValidPin = (pin: string | null): pin is PinCodePattern => {
    if (pin === null) {
        return false;
    }

    if (pin && pin?.length !== 4) {
        return false;
    }

    return pinRegex.test(pin);
};

export default isValidPin;
